document.addEventListener('DOMContentLoaded', () => {
    const coursePreviews = document.querySelectorAll('.course-preview');

    if (!coursePreviews.length) return;

    // Eagerly load videos when tiles scroll into view (helps iOS Safari)
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const video = entry.target.querySelector('.course-tile__video');
                if (video && video.readyState < 3) {
                    video.load();
                }
                observer.unobserve(entry.target);
            }
        });
    }, { rootMargin: '200px' });

    coursePreviews.forEach(preview => {
        observer.observe(preview);

        const video = preview.querySelector('.course-tile__video');

        if (!video) return;

        // Play video on hover
        preview.addEventListener('mouseenter', () => {
            video.play().catch(err => console.log('Video play failed:', err));
        });

        // Pause and reset video when hover ends
        preview.addEventListener('mouseleave', () => {
            video.pause();
            video.currentTime = 0;
        });
    });
});